import fixedPriceProjectTimerecordsModal from "./fixedPriceProjectTimerecordsModal.html";
import {
  buildFixedPriceProjectExportData,
  createFixedPriceProjectColumns,
} from "./fixedPriceProjectsData";

FixedPriceProjectsCtrl.$inject = [
  "$scope",
  "FixedPriceProjects",
  "FixedPriceProjectTimerecords",
  "CustProjects",
  "Modal",
];

export default function FixedPriceProjectsCtrl(
  $scope,
  FixedPriceProjects,
  FixedPriceProjectTimerecords,
  CustProjects,
  Modal
) {
  $scope.selectOptions = { customers: [] };
  $scope.projects = [];
  $scope.exportRows = [];
  $scope.errorMessage = null;

  $scope.fetchCustProjects = function () {
    CustProjects.get(
      {},
      function (data) {
        $scope.selectOptions.customers = data;
      },
      function () {
        $scope.selectOptions.customers = [];
        $scope.errorMessage = "Kunde inte hämta kund- och projektfilter.";
      }
    );
  };

  $scope.fetchCustProjects();

  $scope.formatHours = function (value) {
    if (value === null || value === undefined) {
      return null;
    }

    return value.toLocaleString("sv-SE", { useGrouping: false });
  };

  $scope.formatMoney = function (value) {
    if (value === null || value === undefined) {
      return null;
    }

    return value.toLocaleString("sv-SE", {
      useGrouping: false,
      maximumFractionDigits: 2,
    });
  };

  $scope.columns = createFixedPriceProjectColumns(
    $scope.formatHours,
    $scope.formatMoney
  );
  $scope.getExportHeaders = function () {
    return $scope.columns.map((column) => column.header);
  };
  $scope.getCellValue = function (column, project) {
    return column.value(project);
  };
  $scope.getExportRows = function () {
    return $scope.exportRows;
  };

  $scope.fetchFixedPriceProjects = function () {
    $scope.exportRows = [];
    $scope.projects = [];
    $scope.errorMessage = null;

    const customerId = $scope.selectOptions.customer
      ? $scope.selectOptions.customer.id
      : null;
    const projectId = $scope.selectOptions.project
      ? $scope.selectOptions.project.id
      : null;

    FixedPriceProjects.get(
      {
        customer_id: customerId,
        project_id: projectId,
        include_completed: $scope.selectOptions.includeCompleted,
      },
      function (data) {
        $scope.projects = data;
        $scope.exportRows = buildFixedPriceProjectExportData(
          data,
          $scope.columns
        );
      },
      function () {
        $scope.errorMessage = "Kunde inte hämta fastprisprojekten.";
      }
    );
  };

  $scope.showProjectTimerecords = function (project) {
    $scope.errorMessage = null;

    FixedPriceProjectTimerecords.get(
      { project_id: project.project_id },
      function (data) {
        Modal.showModal(
          {
            template: fixedPriceProjectTimerecordsModal,
            size: "lg",
          },
          {
            closeButtonText: "Stäng",
            headerText: "Tidrapport: " + project.project_name,
            timerecords: data,
            formatHours: $scope.formatHours,
            formatMoney: $scope.formatMoney,
          }
        );
      },
      function () {
        $scope.errorMessage = "Kunde inte hämta tidrapporten.";
      }
    );
  };
}
